import { render, staticRenderFns } from "./MyWr1BookingNote.vue?vue&type=template&id=07282276"
import script from "./MyWr1BookingNote.vue?vue&type=script&lang=js"
export * from "./MyWr1BookingNote.vue?vue&type=script&lang=js"
import style0 from "./MyWr1BookingNote.vue?vue&type=style&index=0&id=07282276&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports